import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export function useItemAlerts(itemId: string) {
  return useQuery({
    queryKey: ['alerts', itemId],
    queryFn: () => apiClient.getItemAlerts(itemId),
    enabled: !!itemId,
  });
}

export function useCreateAlert() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, data }: { itemId: string; data: any }) =>
      apiClient.createAlert(itemId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['alerts', variables.itemId] });
      queryClient.invalidateQueries({ queryKey: ['health'] });
    },
  });
}

export function useResolveAlert() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ alertId, resolved }: { alertId: string; resolved: boolean }) =>
      apiClient.resolveAlert(alertId, resolved),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alerts'] });
      queryClient.invalidateQueries({ queryKey: ['health'] });
    },
  });
}
